module.exports = __webpack_public_path__ + "img/qujiao-bg.5ec384a4.png";